import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "initiator",
  "use": "initiator-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"initiator\">\n  <path d=\"M12.4425 14.6542C14.5876 13.2192 16 10.7745 16 8C16 3.58167 12.4183 0 8 0C7.37536 0 6.76744 0.0716553 6.18401 0.207031L14 9H8L12.4425 14.6542Z\" />\n  <path d=\"M10.6504 15.5505C9.82093 15.8417 8.92896 16 8 16C3.58172 16 0 12.4183 0 8C0 5.04053 1.60699 2.45642 3.99597 1.07263L9.5 7H4L10.6504 15.5505Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol